// ゲーム機画面内の情報ダイアログ（確定デザイン）。OKひとつ。ヒント等の情報表示用。
import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { InScreenModal } from "./ScreenModal";
import { BuilderModalPanel, BuilderModalAccent } from "./BuilderModalPanel";

const OK_BTN: Record<BuilderModalAccent, string> = {
  [BuilderModalAccent.GREEN]: "btn-primary",
  [BuilderModalAccent.BLUE]: "btn-blue",
  [BuilderModalAccent.BROWN]: "btn-primary",
  [BuilderModalAccent.DANGER]: "btn-danger",
  [BuilderModalAccent.ORANGE]: "btn-secondary",
};

export const BuilderInfoDialog = ({
  visible,
  title,
  message,
  close,
  accent = BuilderModalAccent.BLUE,
  icon = "lightbulb",
}: {
  visible: boolean;
  title: string;
  message: string;
  close: () => void;
  accent?: BuilderModalAccent;
  icon?: string;
}) => {
  const play = usePlaySound();
  const handleClose = () => {
    play();
    btnDelay(() => close());
  };

  return (
    <InScreenModal open={visible} onBackdropClose={close}>
      <BuilderModalPanel accent={accent} icon={icon} title={title} width={480}>
        <div className="flex-col-el items-start w-full">
          {message?.split("\n").map((line, index) => (
            <p key={index} className="type-text-left type-body text-textcolor-black mb-2">
              {line}
            </p>
          ))}
        </div>

        <div className="flex-row-el flex-center justify-end w-full px-4 upsilon">
          <button
            type="button"
            onClick={handleClose}
            className={`type-inherit-font btn ${OK_BTN[accent]}`}
          >
            <div className="flex-row-center gap-1">
              <span className="material-symbols-outlined text-white type-md">close</span>
              <p className="type-text type-body text-white">{I18n.t("MSG_CLOSE_BTN")}</p>
            </div>
          </button>
        </div>
      </BuilderModalPanel>
    </InScreenModal>
  );
};
